import { Cell, Row } from "@tanstack/react-table";
import { useEffect, useState } from "react";

import { useTableContext } from "../../context";

export default function CellDate<T>({
  row,
  cell,
}: {
  row: Row<T>;
  cell: Cell<T, unknown>;
}) {
  const { table } = useTableContext();

  const updateData = table?.options?.meta?.updateData;
  const isUpdating = table?.options?.meta?.isUpdating ?? false;
  const columnId = cell.column?.id;
  const cellValue = cell.getValue() as string | undefined;

  // Convert the date value to YYYY-MM-DD format for the input
  const formatDateForInput = (dateString: string | undefined): string => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toISOString().split("T")[0];
    } catch {
      return "";
    }
  };

  const [value, setValue] = useState(formatDateForInput(cellValue));

  useEffect(() => {
    setValue(formatDateForInput(cellValue));
  }, [cellValue]);

  return (
    <input
      type="date"
      value={value}
      onChange={(event) => {
        const newValue = event.target.value;
        setValue(newValue);
      }}
      disabled={isUpdating}
      onBlur={(event) => {
        const newValue = event.target.value;
        const formattedCellValue = formatDateForInput(cellValue);
        if (newValue === formattedCellValue) return;

        try {
          // Send the date in Y-m-d format for the backend
          const dateValue = newValue || null;
          updateData?.(row, columnId, dateValue);
        } catch (error) {
          console.error(error);
          setValue(formattedCellValue);
        }
      }}
      className="w-full px-2 py-1 border border-gray-300 rounded-sm focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
    />
  );
}
